import { AppNotificationLogDto, NotificationObjectCompletedAction } from "@/openapi";
import { Box } from "@mui/material";
import React, { useCallback } from "react";
import { NotificationStatus, NotificationTitle, StyledButton } from "./common";
import { useNotificationContext } from "@/components/NotificationCenter/notification-context.tsx";
import { usePageNavigation } from "@/util/navigation-helper.ts";
import { useTranslation } from "react-i18next";

interface Props {
  notification: AppNotificationLogDto;
  isSameChild?: boolean;
}

export const AppRequest: React.FC<Props> = ({ notification, isSameChild = false }) => {
  const pageNavigate = usePageNavigation();
  const { toggleNotificationPanel } = useNotificationContext();
  const { t } = useTranslation("notifications");

  const handleReviewApp = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      e.preventDefault();
      toggleNotificationPanel();
      pageNavigate("/apps/pending");
    },
    [pageNavigate, toggleNotificationPanel],
  );

  return (
    <Box
      sx={{ width: "100%", display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start", rowGap: 1 }}
    >
      <NotificationTitle>
        <b>{notification.notificationObjectMetadata.props.childName}</b> {t("requestNewApp")}{" "}
        <b>{notification.notificationObjectMetadata.props.appName}</b>
      </NotificationTitle>
      {notification.completedAction &&
        (notification.completedAction === NotificationObjectCompletedAction.Approved ||
          notification.completedAction === NotificationObjectCompletedAction.Rejected) ? (
        notification.completedAction === NotificationObjectCompletedAction.Approved ? (
          <NotificationStatus status="success" text={t("appApproved")} />
        ) : (
          <NotificationStatus status="error" text={t("appRejected")} />
        )
      ) : isSameChild ? (
        <Box sx={{ display: "flex", columnGap: 2, justifyContent: "flex-start", alignItems: "center", width: "100%" }}>
          <StyledButton variant="contained" size="small" onClick={handleReviewApp}>
            {t("reviewApp")}
          </StyledButton>
        </Box>
      ) : null}
    </Box>
  );
};
